import React from 'react'
import { Redirect, Router, Route, Switch } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import ApplicationStyle from './ApplicationStyle'
import { pages } from './constants/pages'

const browserHistory = createBrowserHistory()

/**
 * Application layer that handles routes
 */
const ApplicationRoutes = () => {
  return (
    <Router history={browserHistory}>
      <Switch>
        <Redirect exact from='/' to={pages[1].url} />
        {pages.map((page, index) => (
          <Route key={index} exact path={page.url}>
            <ApplicationStyle pageProps={page} />
          </Route>
        ))}
      </Switch>
    </Router>
  )
}

export default ApplicationRoutes
